
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/weinblog",
      function () {
        return require("private-next-pages/news/weinblog.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/weinblog"])
      });
    }
  